import 'angular';
import './approval_comments_panel.html'
import * as moment from 'moment';

import {RootScope} from "../../../types/angular-types";
import {ApprovalAction, ApprovalStatus, ApprovalActionType} from '../../approvals-types'

interface IScope extends RootScope {
    // properties
    approvalActions: ApprovalAction;

    // methods
    getCommentTitle: (action: ApprovalAction) => string;
    getApprovalActionIndicator: (approvalAction: ApprovalActionType) => string;
    getRelativeTime: (isoDateTime: string) => string;
    
}

angular.module('GorillaBoy.Approvals')
    .directive('approvalCommentsPanel', ['$rootScope', '$translate', ($rootScope: RootScope, $translate: ng.translate.ITranslateService) => {
        return {
            restrict: 'E',
            templateUrl: './approvals/approvalView/approvalCommentsPanel/approval_comments_panel.html',
            scope: {
                approvalActions: '<',
            },
            link: function($scope: IScope, $element, attrs) {
                // INITIALIZATION


                // METHODS
                $scope.getCommentTitle = (action: ApprovalAction) => {
                    if (action.Action === ApprovalActionType.APPROVE) {
                        return $translate.instant('APPROVALS.VIEWER.COMMENTS_PANEL.APPROVED_COMMENT_TITLE', {actor: $rootScope.getFullName(action.Approver)});
                    } else if (action.Action === ApprovalActionType.REJECT) {
                        return $translate.instant('APPROVALS.VIEWER.COMMENTS_PANEL.REJECTED_COMMENT_TITLE', {actor: $rootScope.getFullName(action.Approver)});
                    }

                    return null;
                };

                $scope.getRelativeTime = (isoDateTime: string) => {
                    return moment(isoDateTime).fromNow()
                };

                $scope.getApprovalActionIndicator = (approvalAction: ApprovalActionType) => {
                    switch (approvalAction) {
                        case ApprovalActionType.APPROVE:
                            return 'approval-approved-indicator';
                        case ApprovalActionType.REJECT:
                            return 'approval-rejected-indicator';
                    }
                    return null;
                }

                // HELPER FUNCTIONS
            }
        };
    }]);